'use strict';

function _MortgageController() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_AccountController, _MortgageRedirectionController, _Paths];

  this._history = new History();
  this._initFlags = {
    _mortgageSettingsInitialized: false,
    _mortgageIndexInitialized: false,
    _mortgageApplicationIndexInitialized: false,
    _mortgageApplicationInitialized: false,
    _mortgageParticipantsIndexInitialized: false,
    _mortgageApplicantInitialized: false,
    _mortgageCoparticipantInitialized: false,
    _mortgageApplicantEmploymentInitialized: false,
    _mortgageCoparticipantEmploymentInitialized: false,
    _mortgageApplicantLiabilityMortgageInitialized: false,
    _mortgageCoparticipantLiabilityMortgageInitialized: false,
    _mortgageApplicantLiabilitiesInitialized: false,
    _mortgageCoparticipantLiabilitiesInitialized: false
  };
  this._updateFlags = {
    _mortgageApplicantEmploymentUpdated: true,
    _mortgageCoparticipantEmploymentUpdated: true,
    _mortgageApplicantLiabilityMortgageUpdated: true,
    _mortgageCoparticipantLiabilityMortgageUpdated: true,
    _mortgageApplicantLiabilitiesUpdated: true,
    _mortgageCoparticipantLiabilitiesUpdated: true
  };
  this._callbackComplete = true;
  this._pageInitialized = false;
  this._path = window.location.pathname;

  this.init = function () {
    this._super();
    this.$node = $(this.node);
    this._productSettings = new ProductSettings(this.presenter);

    // Guard to prevent duplication on dashboard home and notification centre
    if (this._path !== this.paths.account.dashboard && this._path !== this.paths.account.settings && this._path !== this.paths.account.notification_centre) {
      this._setupLivechat();
    }
  };

  this.initAllReady = function () {
    // this.$node.hide();
    this._super();
    if (typeof this.initPage !== 'function') {
      this.initPage = function () {};
    }
    this._initMortgageModels();
  };

  this._initPageIfReady = function () {
    if (!this._pageInitialized && this.validateMortgagePageRequest()) {
      this._pageInitialized = true;
      this._removeCallbacksFromActions();
      this.initPage();
      this.$node.show();
    }
  };

  this._setupLivechat = function () {
    // Behavior: Create LiveChat if it's not created
    // Chat should be maximized if chat is 1) already maximized 2)visitor is engaged in convo
    this._liveChat = this.$node.find('.js--live-chat');
    this._liveChatComponent = $("[data-mogo-UI='LiveChat']");

    if (this._liveChat.length && !this._liveChatComponent.length) {
      this._liveChat.mogo().create('LiveChat', {
        presenter: this.presenter,
        afterLoad: function () {
          this._liveChat.mogo().hideChatIfNotEngaged();
        }.bind(this)
      });
    } else if (this._liveChatComponent.length && this._liveChatComponent.mogo().declaredClass) {
      this._liveChat = this._liveChatComponent;
      this._liveChat.mogo().hideChatIfNotEngaged();
    }
  };

  this._initMortgageModels = function () {
    // Mortgage Settings
    if (this.presenter.models.mortgage_settings == null || !this.presenter.models.mortgage_settings._initialized) {
      this._initMortgagesSettingsCallbackId = this.presenter.addCallbackToAction('account.get_mortgage_setting', this._onMortgageSettingsFetch.bind(this));
      if (this.presenter.models.mortgage_settings == null) {
        // Create mortgage_settings model only if the action exists
        if (this.presenter.hasAction('account.get_mortgage_setting')) {
          this.presenter.createModel('mortgage_settings', {
            action: 'account.get_mortgage_setting'
          });
        }
      }
    } else {
      this._initFlags._mortgageSettingsInitialized = true;
    }

    // Funded Mortgages
    if (this.presenter.models.mortgage_funded == null || !this.presenter.models.mortgage_funded._initialized) {
      this._initMortgagesIndexCallbackId = this.presenter.addCallbackToAction('account.index_mortgages', this._onMortgageIndexModelFetch.bind(this));
      if (this.presenter.models.mortgage_funded == null) {
        // Create mortgage_funded index model only if model does not exist
        if (this.presenter.hasAction('account.index_mortgages')) {
          this.presenter.createModel('mortgage_funded', { action: 'account.index_mortgages' });
        } else {
          this._initFlags._mortgageIndexInitialized = true;
        }
      }
    } else {
      // Funded Mortgages model exists
      this._initFlags._mortgageIndexInitialized = true;
    }

    // Mortgage Applications
    if (this.presenter.models.mortgage_applications == null || !this.presenter.models.mortgage_applications._initialized) {
      this._initMortgageApplicationsIndexCallbackId = this.presenter.addCallbackToAction('account.index_mortgage_applications', this._onMortgagesModelFetch.bind(this));
      if (this.presenter.models.mortgage_applications == null) {
        // Create mortgage_applications index model only if model does not exist
        if (this.presenter.hasAction('account.index_mortgage_applications')) {
          this.presenter.createModel('mortgage_applications', {
            action: 'account.index_mortgage_applications'
          });
        } else {}
      }
    } else {
      // Mortgages model exists
      this._initFlags._mortgageApplicationIndexInitialized = true;
      this._initFlags._mortgageApplicationInitialized = true;
      this._initializePrimaryMortgageDependentModels();
    }
  };

  this._onMortgageSettingsFetch = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized) {
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: 'account.get_mortgage_setting' }, { productLabel: 'MogoMortgage' }, null, this._connectionIssueConfig);
      }
    } else {
      if (response !== 200) return;
      if (this._initMortgagesSettingsCallbackId) {
        this.presenter.removeCallbackFromAction('account.get_mortgage_setting', this._initMortgagesSettingsCallbackId);
      }
      this._errorInitialized = false;
      this._initFlags._mortgageSettingsInitialized = true;
      this._initPageIfReady();
    }
  };

  // Helper Method to be used by every page to push analytics about mortgage choices
  this.pushAnalyticsMortgageChoices = function () {
    if (this._isMortgageOptionsComplete()) {
      var data = { applicationType: [this.presenter.models.mortgage.type] };
      if (this._isBackupSoloComplete()) {
        data.applicantInfo = [this.presenter.models.mortgage.has_supporter == 1 ? this.presenter.models.mortgage_coparticipant.type : 'solo'];
      }
      if (this._isLiabilityDetailsComplete()) {
        data.applicantLiabilities = [this.presenter.models.mortgage_applicant.has_existing_mortgages];
        data.coLiabilities = [this.presenter.models.mortgage_coparticipant.has_existing_mortgages];
      }
      if (this._isConsentCheckComplete()) {
        data.bankrupt = [this.presenter.models.mortgage.was_bankrupt];
      }
      this.analytics.forcePushEvent('mortgage-choices', data);
    }
  };

  this.pushAnalyticsMortgageInfo = function () {
    // mortgage status analytics data
    var mortgageStatus = 'Eligible';

    if (!this.presenter.hasAction('account.create_mortgage_application')) {
      if (this.presenter.models.mortgage_applications.mortgage_applications.length > 0) {
        mortgageStatus = 'Not Eligible';
      } else {
        mortgageStatus = 'Province not Supported';
      }
    }

    switch (this.presenter.models.mortgage.status) {
      case 'opened':
        mortgageStatus = 'In-progress';
        break;
      case 'submitted':
        mortgageStatus = 'Submitted';
        break;
      case 'pre_approved':
        mortgageStatus = 'Offer made';
        break;
      case 'declined':
        mortgageStatus = 'Declined';
        break;
      case 'funded':
        mortgageStatus = 'Funded';
        var mortgageType = this.presenter.getModelProperty('mortgage_funded.mortgages[0].type');
        if (mortgageType == 'fixed') {
          mortgageStatus += ' Fixed';
        } else if (mortgageType == 'variable') {
          mortgageStatus += ' Variable';
        }
        break;
    }

    var analyticsObject = { mortgageStatus: [mortgageStatus] };

    if (this._isMortgageOptionsComplete()) {
      analyticsObject.mortgageStarted = [this.presenter.models.mortgage.created_at];
    }
    if (this._isConsentCheckComplete()) {
      analyticsObject.mortgageSubmitted = [this.presenter.models.mortgage.credit_check_consented_at];
    }

    this.analytics.forcePushEvent('mortgageInfo', analyticsObject);
  };

  this._onMortgageIndexModelFetch = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized) {
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: 'account.index_mortgages' }, { productLabel: 'MogoMortgage' }, null, this._connectionIssueConfig);
      }
    } else {
      if (response !== 200) return;
      if (this._initMortgagesIndexCallbackId) {
        this.presenter.removeCallbackFromAction('account.index_mortgages', this._initMortgagesIndexCallbackId);
      }
      this._errorInitialized = false;
      this._initFlags._mortgageIndexInitialized = true;

      if (this.presenter.models.mortgage) this._initializePrimaryMortgageDependentModels();
    }
  };

  this._onMortgagesModelFetch = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized) {
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: 'account.index_mortgage_applications' }, { productLabel: 'MogoMortgage' }, null, this._connectionIssueConfig);
      }
    } else {
      if (response !== 200) return;
      if (this._initMortgageApplicationsIndexCallbackId) {
        this.presenter.removeCallbackFromAction('account.index_mortgage_applications', this._initMortgageApplicationsIndexCallbackId);
      }
      this._errorInitialized = false;
      this._initFlags._mortgageApplicationIndexInitialized = true;

      // Retrieve mortgage applications if exist
      if (this.presenter.models.mortgage == null) {
        if (this.presenter.models.mortgage_applications.mortgage_applications.length > 0) {
          // Currently support for one mortgage only
          this.presenter.createModel('mortgage', {
            data: this.presenter.models.mortgage_applications.mortgage_applications[0]
          });
        } else {
          this.presenter.createModel('mortgage', { data: {} });
        }
      }
      this._initFlags._mortgageApplicationInitialized = true;

      this._initializePrimaryMortgageDependentModels();
    }
  };

  this._initializePrimaryMortgageDependentModels = function () {
    // Participants model (index) and co-participant model
    if (this._requiresParticipantModel()) {
      this._initParticipantsCallbackId = this.presenter.addCallbackToAction('mortgage.index_mortgage_participants', this._onRetrieveParticipantsModel.bind(this));
      if (this.presenter.models.mortgage_participants == null) {
        this.presenter.createModel('mortgage_participants', {
          action: 'mortgage.index_mortgage_participants'
        });
      } else if (this.presenter.models.mortgage_participants._initialized) {
        this._initFlags._mortgageParticipantsIndexInitialized = true;
        this._initFlags._mortgageApplicantInitialized = true;
        this._initFlags._mortgageCoparticipantInitialized = true;

        this._initializeSecondaryMortgageDependentModels();
      }
    } else {
      if (this.presenter.models.mortgage_participants == null) {
        this.presenter.createModel('mortgage_participants', { data: {} });
        this.presenter.createModel('mortgage_applicant', { data: {} });
        this.presenter.createModel('mortgage_coparticipant', { data: {} });
      }
      this._initFlags._mortgageParticipantsIndexInitialized = true;
      this._initFlags._mortgageApplicantInitialized = true;
      this._initFlags._mortgageCoparticipantInitialized = true;

      this._initializeSecondaryMortgageDependentModels();
    }
  };

  this._initializeSecondaryMortgageDependentModels = function () {
    // Employment model (applicant)
    if (this._requiresEmploymentModel('applicant')) {
      this._initApplicantEmploymentCallbackId = this.presenter.addCallbackToAction('mortgage_applicant.index_mortgage_employments', this._onRetrieveEmploymentModel.bind(this, 'applicant'));
      if (this.presenter.models.mortgage_applicant_employment == null || !this.presenter.models.mortgage_applicant_employment.links && this.presenter.models.mortgage_applicant_employment._initialized) {
        this.presenter.createModel('mortgage_applicant_employment', {
          action: 'mortgage_applicant.index_mortgage_employments'
        });
      } else if (this.presenter.models.mortgage_applicant_employment._initialized) {
        this._initFlags._mortgageApplicantEmploymentInitialized = true;
      }
    } else {
      if (this.presenter.models.mortgage_applicant_employment == null) {
        this.presenter.createModel('mortgage_applicant_employment', { data: {} });
      }
      this._initFlags._mortgageApplicantEmploymentInitialized = true;
    }

    // Employment model (coparticipant)
    if (this._requiresEmploymentModel('coparticipant')) {
      this._initCoparticipantEmploymentCallbackId = this.presenter.addCallbackToAction('mortgage_coparticipant.index_mortgage_employments', this._onRetrieveEmploymentModel.bind(this, 'coparticipant'));
      if (this.presenter.models.mortgage_coparticipant_employment == null || !this.presenter.models.mortgage_coparticipant_employment.links && this.presenter.models.mortgage_coparticipant_employment._initialized) {
        this.presenter.createModel('mortgage_coparticipant_employment', {
          action: 'mortgage_coparticipant.index_mortgage_employments'
        });
      } else if (this.presenter.models.mortgage_coparticipant_employment._initialized) {
        this._initFlags._mortgageCoparticipantEmploymentInitialized = true;
      }
    } else {
      this._initFlags._mortgageCoparticipantEmploymentInitialized = true;
    }

    // Liability mortgage model (applicant)
    if (this._requiresLiabilityMortgageModel('applicant')) {
      this._initApplicantLiabilityMortgageCallbackId = this.presenter.addCallbackToAction('mortgage_applicant.index_mortgage_existing_mortgages', this._onRetrieveLiabilityMortgageModel.bind(this, 'applicant'));
      if (this.presenter.models.mortgage_applicant_mortgage_liability == null || !this.presenter.models.mortgage_applicant_mortgage_liability.links && this.presenter.models.mortgage_applicant_mortgage_liability._initialized) {
        this.presenter.createModel('mortgage_applicant_mortgage_liability', {
          action: 'mortgage_applicant.index_mortgage_existing_mortgages'
        });
      } else if (this.presenter.models.mortgage_applicant_mortgage_liability._initialized) {
        this._initFlags._mortgageApplicantLiabilityMortgageInitialized = true;
      }
    } else {
      if (this.presenter.models.mortgage_applicant_mortgage_liability == null) {
        this.presenter.createModel('mortgage_applicant_mortgage_liability', { data: {} });
      }
      this._initFlags._mortgageApplicantLiabilityMortgageInitialized = true;
    }

    // Liability mortgage model (coparticipant)
    if (this._requiresLiabilityMortgageModel('coparticipant')) {
      this._initCoparticipantLiabilityMortgageCallbackId = this.presenter.addCallbackToAction('mortgage_coparticipant.index_mortgage_existing_mortgages', this._onRetrieveLiabilityMortgageModel.bind(this, 'coparticipant'));
      if (this.presenter.models.mortgage_coparticipant_mortgage_liability == null || !this.presenter.models.mortgage_coparticipant_mortgage_liability.links && this.presenter.models.mortgage_coparticipant_mortgage_liability._initialized) {
        this.presenter.createModel('mortgage_coparticipant_mortgage_liability', {
          action: 'mortgage_coparticipant.index_mortgage_existing_mortgages'
        });
      } else if (this.presenter.models.mortgage_coparticipant_mortgage_liability._initialized) {
        this._initFlags._mortgageCoparticipantLiabilityMortgageInitialized = true;
      }
    } else {
      this._initFlags._mortgageCoparticipantLiabilityMortgageInitialized = true;
    }

    // Liabilities child_support and alimony (applicant)
    // Does this participant require this model?
    if (this._requiresLiabilitiesModel('applicant')) {
      // Create a callback on that action
      this._initApplicantLiabilitiesCallbackId = this.presenter.addCallbackToAction('mortgage_applicant.index_mortgage_liabilities', this._onRetrieveLiabilitiesModel.bind(this, 'applicant'));
      // Check if the model has already been initialized
      if (this.presenter.models.mortgage_applicant_liabilities == null || !this.presenter.models.mortgage_applicant_liabilities.links && this.presenter.models.mortgage_applicant_liabilities._initialized) {
        // Create the model to start initialization
        this.presenter.createModel('mortgage_applicant_liabilities', {
          action: 'mortgage_applicant.index_mortgage_liabilities'
        });
      } else if (this.presenter.models.mortgage_applicant_liabilities._initialized) {
        // Already Initialized
        this._initFlags._mortgageApplicantLiabilitiesInitialized = true;
      }
    } else {
      // Doesn't require the model
      if (this.presenter.models.mortgage_applicant_liabilities == null) {
        this.presenter.createModel('mortgage_applicant_liabilities', { data: {} });
      }
      this._initFlags._mortgageApplicantLiabilitiesInitialized = true;
    }

    // Liabilities child_support and alimony (coparticipant)
    // Does this participant require this model?
    if (this._requiresLiabilitiesModel('coparticipant')) {
      // Create a callback on that action
      this._initCoparticipantLiabilitiesCallbackId = this.presenter.addCallbackToAction('mortgage_coparticipant.index_mortgage_liabilities', this._onRetrieveLiabilitiesModel.bind(this, 'coparticipant'));
      // Check if the model has already been initialized
      if (this.presenter.models.mortgage_coparticipant_liabilities == null || !this.presenter.models.mortgage_coparticipant_liabilities.links && this.presenter.models.mortgage_coparticipant_liabilities._initialized) {
        // Create the model to start initialization
        this.presenter.createModel('mortgage_coparticipant_liabilities', {
          action: 'mortgage_coparticipant.index_mortgage_liabilities'
        });
      } else if (this.presenter.models.mortgage_coparticipant_liabilities._initialized) {
        // Already Initialized
        this._initFlags._mortgageCoparticipantLiabilitiesInitialized = true;
      }
    } else {
      // Doesn't require the model
      this._initFlags._mortgageCoparticipantLiabilitiesInitialized = true;
    }

    this._initPageIfReady();
  };

  this._onRetrieveParticipantsModel = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized) {
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: 'mortgage.index_mortgage_participants' }, { productLabel: 'MogoMortgage' }, null, this._connectionIssueConfig);
      }
    } else {
      if (response !== 200) return;
      if (this._initParticipantsCallbackId) {
        this.presenter.removeCallbackFromAction('mortgage.index_mortgage_participants', this._initParticipantsCallbackId);
      }
      this._errorInitialized = false;
      this._initFlags._mortgageParticipantsIndexInitialized = true;

      var len = this.presenter.models.mortgage_participants.participants.length;

      // Retrieve applicant
      if (this.presenter.models.mortgage_applicant == null) {
        for (var i = 0; i <= len - 1; i++) {
          var participant = this.presenter.models.mortgage_participants.participants[i];
          if (participant.type == 'applicant') {
            this.presenter.createModel('mortgage_applicant', { data: participant });
            break;
          }
        }
      }
      this._initFlags._mortgageApplicantInitialized = true;

      // Retrieve co-participant if exist - current support for only one coparticipant
      if (this.presenter.models.mortgage_coparticipant == null) {
        if (len > 1) {
          for (var i = len - 1; i >= 0; i--) {
            var participant = this.presenter.models.mortgage_participants.participants[i];
            if (participant.type != 'applicant') {
              this.presenter.createModel('mortgage_coparticipant', { data: participant });
              break;
            }
          }
        } else {
          this.presenter.createModel('mortgage_coparticipant', { data: {} });
        }
      }
      this._initFlags._mortgageCoparticipantInitialized = true;

      this._initializeSecondaryMortgageDependentModels();
    }
  };

  this._onRetrieveEmploymentModel = function (type, data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized) {
        this._errorInitialized = true;
        if (type == 'applicant') {
          this.invokeConnectionIssuePage({ action: 'mortgage_applicant.index_mortgage_employments' }, { productLabel: 'MogoMortgage' }, null, this._connectionIssueConfig);
        } else {
          this.invokeConnectionIssuePage({ action: 'mortgage_coparticipant.index_mortgage_employments' }, { productLabel: 'MogoMortgage' }, null, this._connectionIssueConfig);
        }
      }
    } else {
      if (response !== 200) return;
      this._errorInitialized = false;
      if (type == 'applicant') {
        this._initFlags._mortgageApplicantEmploymentInitialized = true;
        if (this._initApplicantEmploymentCallbackId) {
          this.presenter.removeCallbackFromAction('mortgage_applicant.index_mortgage_employments', this._initApplicantEmploymentCallbackId);
        }
      } else {
        this._initFlags._mortgageCoparticipantEmploymentInitialized = true;
        if (this._initCoparticipantEmploymentCallbackId) {
          this.presenter.removeCallbackFromAction('mortgage_coparticipant.index_mortgage_employments', this._initCoparticipantEmploymentCallbackId);
        }
      }
    }

    if (data.employments.length > 0) {
      if (type == 'applicant') {
        this.presenter.updateModel('mortgage_applicant_employment', data.employments[0]);
      } else {
        this.presenter.updateModel('mortgage_coparticipant_employment', data.employments[0]);
      }
    }

    this._initPageIfReady();
  };

  this._onRetrieveLiabilityMortgageModel = function (type, data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized) {
        this._errorInitialized = true;
        if (type == 'applicant') {
          this.invokeConnectionIssuePage({ action: 'mortgage_applicant.index_mortgage_existing_mortgages' }, { productLabel: 'MogoMortgage' }, null, this._connectionIssueConfig);
        } else {
          this.invokeConnectionIssuePage({ action: 'mortgage_coparticipant.index_mortgage_existing_mortgages' }, { productLabel: 'MogoMortgage' }, null, this._connectionIssueConfig);
        }
      }
    } else {
      if (response !== 200) return;
      this._errorInitialized = false;
      if (type == 'applicant') {
        this._initFlags._mortgageApplicantLiabilityMortgageInitialized = true;
        if (this._initApplicantLiabilityMortgageCallbackId) {
          this.presenter.removeCallbackFromAction('mortgage_applicant.index_mortgage_existing_mortgages', this._initApplicantLiabilityMortgageCallbackId);
        }
      } else {
        this._initFlags._mortgageCoparticipantLiabilityMortgageInitialized = true;
        if (this._initCoparticipantLiabilityMortgageCallbackId) {
          this.presenter.removeCallbackFromAction('mortgage_coparticipant.index_mortgage_existing_mortgages', this._initCoparticipantLiabilityMortgageCallbackId);
        }
      }
    }

    if (data.existing_mortgages.length > 0) {
      if (type == 'applicant') {
        this.presenter.updateModel('mortgage_applicant_mortgage_liability', data.existing_mortgages[0]);
      } else {
        this.presenter.updateModel('mortgage_coparticipant_mortgage_liability', data.existing_mortgages[0]);
      }
    }

    this._initPageIfReady();
  };

  this._onRetrieveLiabilitiesModel = function (type, data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized) {
        this._errorInitialized = true;
        if (type == 'applicant') {
          this.invokeConnectionIssuePage({ action: 'mortgage_applicant.index_mortgage_liabilities' }, { productLabel: 'MogoMortgage' }, null, this._connectionIssueConfig);
        } else {
          this.invokeConnectionIssuePage({ action: 'mortgage_coparticipant.index_mortgage_liabilities' }, { productLabel: 'MogoMortgage' }, null, this._connectionIssueConfig);
        }
      }
    } else {
      if (response !== 200) return;
      this._errorInitialized = false;
      if (type == 'applicant') {
        this._initFlags._mortgageApplicantLiabilitiesInitialized = true;
        if (this._initApplicantLiabilitiesCallbackId) {
          this.presenter.removeCallbackFromAction('mortgage_applicant.index_mortgage_liabilities', this._initApplicantLiabilitiesCallbackId);
        }
      } else {
        this._initFlags._mortgageCoparticipantLiabilitiesInitialized = true;
        if (this._initCoparticipantLiabilitiesCallbackId) {
          this.presenter.removeCallbackFromAction('mortgage_coparticipant.index_mortgage_liabilities', this._initCoparticipantLiabilitiesCallbackId);
        }
      }
    }
    this._initPageIfReady();
  };

  this._requiresParticipantModel = function () {
    if (this._requiresModel('mortgage.index_mortgage_participants', 'mortgage_participants')) {
      return true;
    }

    return false;
  };

  this._requiresEmploymentModel = function (type) {
    if (type == 'coparticipant' && !this.presenter.models.mortgage.has_supporter) {
      return false;
    }

    if (this._requiresModel('mortgage_' + type + '.index_mortgage_employments', 'mortgage_' + type + '_employment')) {
      return true;
    }

    return false;
  };

  this._requiresLiabilityMortgageModel = function (type) {
    if (type == 'coparticipant' && !this.presenter.models.mortgage.has_supporter) {
      return false;
    }
    // Does the Participant require Existing Mortgages Model?
    if (this._requiresModel('mortgage_' + type + '.index_mortgage_existing_mortgages', 'mortgage_' + type + '_mortgage_liability')) {
      return true;
    }

    return false;
  };

  this._requiresLiabilitiesModel = function (type) {
    if (type == 'coparticipant' && !this.presenter.models.mortgage.has_supporter) {
      return false;
    }
    // Does the Participant require Child Support and Aliony Model?
    if (this._requiresModel('mortgage_' + type + '.index_mortgage_liabilities', 'mortgage_' + type + '_liabilities')) {
      return true;
    }

    return false;
  };

  this._requiresModel = function (action, modelName) {
    if (this.presenter.hasAction(action)) {
      if (this.presenter.models[modelName] == null || !this.presenter.models[modelName]._initialized) {
        return true;
      }
      if (this.presenter.models[modelName]._initialized && !this.presenter.models[modelName].links) {
        return true;
      }
    }
  };

  this._isMortgageOptionsComplete = function () {
    if (this.presenter.models.mortgage.type != null) {
      return this.presenter.models.mortgage.type === 'refinance' || this.presenter.models.mortgage.type === 'home_purchase' && typeof this.presenter.models.mortgage.is_first_time_home_buyer !== 'undefined';
    }
    return false;
  };

  this._isBackupSoloComplete = function () {
    if (this.presenter.models.mortgage.has_supporter != null) {
      if (!this.presenter.models.mortgage.has_supporter && ( // has no supporter
      !this.presenter.models.account.credit_score || this.presenter.models.account.credit_score < this.presenter.models.mortgage_settings.credit_score_threshold) // and no longer is able to satify threshold
      ) {
          return false;
        }
      return true;
    }
    return false;
  };

  this._isEmploymentInfoComplete = function () {
    if (this.presenter.hasAction('mortgage_applicant_employment.update_mortgage_employment')) {
      if (this.presenter.models.mortgage.has_supporter) {
        if (!this.presenter.hasAction('mortgage_coparticipant_employment.update_mortgage_employment')) {
          return false;
        }
      }
      return true;
    }
    return false;
  };

  this._isLiabilityDetailsComplete = function () {
    if (typeof this.presenter.models.mortgage_applicant.has_existing_mortgages === 'boolean') {
      if (typeof this.presenter.getModelProperty('mortgage_applicant.has_liabilities') !== 'boolean') {
        return false;
      }
      if (this.presenter.models.mortgage.has_supporter) {
        if (typeof this.presenter.models.mortgage_coparticipant.has_existing_mortgages !== 'boolean') {
          return false;
        }
        if (typeof this.presenter.getModelProperty('mortgage_coparticipant.has_liabilities') !== 'boolean') {
          return false;
        }
      }
      return true;
    }
    return false;
  };

  this._isMortgageDetailsComplete = function () {
    var result = this.presenter.models.mortgage.property_usage;
    if (this.presenter.models.mortgage.type === 'home_purchase') {
      result = result && this.presenter.models.mortgage.property_market_value_amount;
    }
    return result;
  };

  this._isConsentCheckComplete = function () {
    return this.presenter.models.mortgage.credit_check_consented_at;
  };

  /*
      Updates the mortgage application and all relevant models (mortgage_applications, participants, employment, liabilities)
  */
  this.updateMortgageApplication = function (callback) {
    if (this.presenter.models.mortgage_applications) {
      this._updateMortgageApplicationCallbackId = this.presenter.addCallbackToAction('mortgage_applications.self', this._onUpdateMortgageApplication.bind(this, callback));
      this.presenter.updateModel('mortgage_applications');
    }
  };

  /*
      Updates the mortgage participants and all relevant models (employment, liabilities)
  */
  this.updateMortgageParticipants = function (callback) {
    if (!this.presenter.models.mortgage_participants.links) {
      this.presenter.createModel('mortgage_participants', { action: 'mortgage.index_mortgage_participants' }, this._onUpdateMortgageParticipants.bind(this, callback));
    } else {
      this._updateMortgageParticipantsCallbackId = this.presenter.addCallbackToAction('mortgage_participants.self', this._onUpdateMortgageParticipants.bind(this, callback));
      this.presenter.updateModel('mortgage_participants');
    }
  };

  /*
      Updates the mortgage participant employments
  */
  this.updateMortgageParticipantsEmployment = function (callback) {
    // Set flags
    this._callbackComplete = false;
    this._updateFlags._mortgageApplicantEmploymentUpdated = false;
    this._updateFlags._mortgageCoparticipantEmploymentUpdated = false;

    if (!this.presenter.models.mortgage.has_supporter) {
      this._updateFlags._mortgageCoparticipantEmploymentUpdated = true;
      if (this.presenter.models.mortgage_coparticipant_employment) {
        delete this.presenter.models.mortgage_coparticipant_employment;
      }
    }

    if (this.presenter.hasAction('mortgage_applicant.index_mortgage_employments')) {
      this._updateMortgageApplicantEmploymentCallbackId = this.presenter.addCallbackToAction('mortgage_applicant.index_mortgage_employments', this._onUpdateMortgageParticipantsEmployment.bind(this, callback, 'applicant'));
      this.presenter.performAction('mortgage_applicant.index_mortgage_employments');
    } else {
      this._updateFlags._mortgageApplicantEmploymentUpdated = true;
    }

    if (this.presenter.hasAction('mortgage_coparticipant.index_mortgage_employments')) {
      this._updateMortgageCoparticipantEmploymentCallbackId = this.presenter.addCallbackToAction('mortgage_coparticipant.index_mortgage_employments', this._onUpdateMortgageParticipantsEmployment.bind(this, callback, 'coparticipant'));
      this.presenter.performAction('mortgage_coparticipant.index_mortgage_employments');
    } else {
      this._updateFlags._mortgageCoparticipantEmploymentUpdated = true;
    }

    this._callbackAfterUpdate(callback);
  };

  /*
      Updates the mortgage participant liabilities
  */
  this.updateMortgageParticipantsLiabilitiesMortgage = function (callback) {
    // Set flags
    this._callbackComplete = false;
    this._updateFlags._mortgageApplicantLiabilityMortgageUpdated = false;
    this._updateFlags._mortgageCoparticipantLiabilityMortgageUpdated = false;
    this._updateFlags._mortgageApplicantLiabilitiesUpdated = false;
    this._updateFlags._mortgageCoparticipantLiabilitiesUpdated = false;

    if (!this.presenter.models.mortgage.has_supporter) {
      this._updateFlags._mortgageCoparticipantLiabilityMortgageUpdated = true;
      this._updateFlags._mortgageCoparticipantLiabilitiesUpdated = true;
      if (this.presenter.models.mortgage_coparticipant_mortgage_liability) {
        delete this.presenter.models.mortgage_coparticipant_mortgage_liability;
      }
      if (this.presenter.models.mortgage_coparticipant_liabilities) {
        delete this.presenter.models.mortgage_coparticipant_liabilities;
      }
    }

    if (this.presenter.hasAction('mortgage_applicant.index_mortgage_existing_mortgages')) {
      this._updateMortgageApplicantLiabilityMortgageCallbackId = this.presenter.addCallbackToAction('mortgage_applicant.index_mortgage_existing_mortgages', this._onUpdateMortgageParticipantsLiabilitiesMortgage.bind(this, callback, 'applicant'));
      this.presenter.performAction('mortgage_applicant.index_mortgage_existing_mortgages');
    } else {
      this._updateFlags._mortgageApplicantLiabilityMortgageUpdated = true;
    }

    if (this.presenter.hasAction('mortgage_coparticipant.index_mortgage_existing_mortgages')) {
      this._updateMortgageCoparticipantLiabilityMortgageCallbackId = this.presenter.addCallbackToAction('mortgage_coparticipant.index_mortgage_existing_mortgages', this._onUpdateMortgageParticipantsLiabilitiesMortgage.bind(this, callback, 'coparticipant'));
      this.presenter.performAction('mortgage_coparticipant.index_mortgage_existing_mortgages');
    } else {
      this._updateFlags._mortgageCoparticipantLiabilityMortgageUpdated = true;
    }

    // Child Support and Alimony Liabilities
    if (this.presenter.hasAction('mortgage_applicant.index_mortgage_liabilities')) {
      this._updateMortgageApplicantLiabilitiesCallbackId = this.presenter.addCallbackToAction('mortgage_applicant.index_mortgage_liabilities', this._onUpdateMortgageParticipantsLiabilities.bind(this, callback, 'applicant'));
      this.presenter.performAction('mortgage_applicant.index_mortgage_liabilities');
    } else {
      this._updateFlags._mortgageApplicantLiabilitiesUpdated = true;
    }

    if (this.presenter.hasAction('mortgage_coparticipant.index_mortgage_liabilities')) {
      this._updateMortgageCoparticipantLiabilitiesCallbackId = this.presenter.addCallbackToAction('mortgage_coparticipant.index_mortgage_liabilities', this._onUpdateMortgageParticipantsLiabilities.bind(this, callback, 'coparticipant'));
      this.presenter.performAction('mortgage_coparticipant.index_mortgage_liabilities');
    } else {
      this._updateFlags._mortgageCoparticipantLiabilitiesUpdated = true;
    }

    this._callbackAfterUpdate(callback);
  };

  this._onUpdateMortgageApplication = function (callback, data, response) {
    if (this._updateMortgageApplicationCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_applications.self', this._updateMortgageApplicationCallbackId);
    }

    if (data.mortgage_applications.length > 0) {
      this.presenter.updateModel('mortgage', data.mortgage_applications[0]);
      this.updateMortgageParticipants(callback);
    } else {
      callback();
    }
  };

  this._onUpdateMortgageParticipants = function (callback, data, response) {
    if (this._updateMortgageParticipantsCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_participants.self', this._updateMortgageParticipantsCallbackId);
    }

    // Update applicant and coparticipants model
    var applicantData = null;
    var coparticipantData = null;
    var participants = this.presenter.models.mortgage_participants.participants;

    if (participants) {
      for (var i = 0; i < participants.length; i++) {
        if (applicantData && coparticipantData) break;

        var participant = participants[i];
        if (participant.type == 'applicant') {
          applicantData = participant;
        } else {
          coparticipantData = participant;
        }
      }
    }

    if (applicantData) {
      if (this.presenter.models.mortgage_applicant) {
        this.presenter.updateModel('mortgage_applicant', applicantData);
      } else {
        this.presenter.createModel('mortgage_applicant', { data: applicantData });
      }
    }

    if (coparticipantData) {
      if (this.presenter.models.mortgage_coparticipant) {
        this.presenter.updateModel('mortgage_coparticipant', coparticipantData);
      } else {
        this.presenter.createModel('mortgage_coparticipant', { data: coparticipantData });
      }
    } else {
      this.presenter.updateModel('mortgage_coparticipant', {});
    }

    // Set flags and update employment and liabilities
    this._callbackComplete = false;
    this._updateFlags._mortgageApplicantEmploymentUpdated = false;
    this._updateFlags._mortgageCoparticipantEmploymentUpdated = false;
    this._updateFlags._mortgageApplicantLiabilityMortgageUpdated = false;
    this._updateFlags._mortgageCoparticipantLiabilityMortgageUpdated = false;
    this.updateMortgageParticipantsEmployment(callback);
    this.updateMortgageParticipantsLiabilitiesMortgage(callback);
  };

  this._onUpdateMortgageParticipantsEmployment = function (callback, type, data, response) {
    if (type == 'applicant') {
      this._updateFlags._mortgageApplicantEmploymentUpdated = true;
      if (this._updateMortgageApplicantEmploymentCallbackId) {
        this.presenter.removeCallbackFromAction('mortgage_applicant.index_mortgage_employments', this._updateMortgageApplicantEmploymentCallbackId);
      }
    } else {
      this._updateFlags._mortgageCoparticipantEmploymentUpdated = true;
      if (this._updateMortgageCoparticipantEmploymentCallbackId) {
        this.presenter.removeCallbackFromAction('mortgage_coparticipant.index_mortgage_employments', this._updateMortgageCoparticipantEmploymentCallbackId);
      }
    }
    if (data.employments.length > 0) {
      data = data.employments[0];
    }
    if (this.presenter.models['mortgage_' + type + '_employment']) {
      this.presenter.updateModel('mortgage_' + type + '_employment', data);
    } else {
      this.presenter.createModel('mortgage_' + type + '_employment', { data: data });
    }
    this._callbackAfterUpdate(callback);
  };

  this._onUpdateMortgageParticipantsLiabilitiesMortgage = function (callback, type, data, response) {
    if (type == 'applicant') {
      this._updateFlags._mortgageApplicantLiabilityMortgageUpdated = true;
      if (this._updateMortgageApplicantLiabilityMortgageCallbackId) {
        this.presenter.removeCallbackFromAction('mortgage_applicant.index_mortgage_existing_mortgages', this._updateMortgageApplicantLiabilityMortgageCallbackId);
      }
    } else {
      this._updateFlags._mortgageCoparticipantLiabilityMortgageUpdated = true;
      if (this._updateMortgageCoparticipantLiabilityMortgageCallbackId) {
        this.presenter.removeCallbackFromAction('mortgage_coparticipant.index_mortgage_existing_mortgages', this._updateMortgageCoparticipantLiabilityMortgageCallbackId);
      }
    }
    if (data.existing_mortgages.length > 0) {
      data = data.existing_mortgages[0];
    }
    if (this.presenter.models['mortgage_' + type + '_mortgage_liability']) {
      this.presenter.updateModel('mortgage_' + type + '_mortgage_liability', data);
    } else {
      this.presenter.createModel('mortgage_' + type + '_mortgage_liability', { data: data });
    }
    this._callbackAfterUpdate(callback);
  };

  // Child Support and Alimony liabilities
  this._onUpdateMortgageParticipantsLiabilities = function (callback, type, data, response) {
    if (type == 'applicant') {
      this._updateFlags._mortgageApplicantLiabilitiesUpdated = true;
      if (this._updateMortgageApplicantLiabilitiesCallbackId) {
        this.presenter.removeCallbackFromAction('mortgage_applicant.index_mortgage_liabilities', this._updateMortgageApplicantLiabilitiesCallbackId);
      }
    } else {
      this._updateFlags._mortgageCoparticipantLiabilitiesUpdated = true;
      if (this._updateMortgageCoparticipantLiabilitiesCallbackId) {
        this.presenter.removeCallbackFromAction('mortgage_coparticipant.index_mortgage_liabilities', this._updateMortgageCoparticipantLiabilitiesCallbackId);
      }
    }
    if (this.presenter.models['mortgage_' + type + '_liabilities']) {
      this.presenter.updateModel('mortgage_' + type + '_liabilities', data);
    } else {
      this.presenter.createModel('mortgage_' + type + '_liabilities', { data: data });
    }
    this._callbackAfterUpdate(callback);
  };

  this._callbackAfterUpdate = function (callback) {
    for (var p in this._updateFlags) {
      if (!this._updateFlags[p]) return false;
    }

    // Reset callback
    if (!this._callbackComplete) {
      this._callbackComplete = true;
      callback();
    }
  };

  this.destroy = function () {
    var isMortgage = window.location.href.indexOf('mortgage') !== -1;
    // Note: components get destroyed on view switch on some places (),
    // which is why sometimes mogo() of undefined error comes up.
    if (!isMortgage && this._liveChat) {
      if (this._liveChat.length && this._liveChat.mogo() && this._liveChat.mogo().declaredClass && this._liveChat.mogo().clear) {
        this._liveChat.mogo().clear();
      }
    }
  };

  this._removeCallbacksFromActions = function () {
    // Initialize models callbacks
    if (this._initMortgagesSettingsCallbackId) {
      this.presenter.removeCallbackFromAction('account.get_mortgage_setting', this._initMortgagesSettingsCallbackId);
    }

    if (this._initMortgagesIndexCallbackId) {
      this.presenter.removeCallbackFromAction('account.index_mortgages', this._initMortgagesIndexCallbackId);
    }

    if (this._initMortgageApplicationsIndexCallbackId) {
      this.presenter.removeCallbackFromAction('account.index_mortgage_applications', this._initMortgageApplicationsIndexCallbackId);
    }

    if (this._initParticipantsCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage.index_mortgage_participants', this._initParticipantsCallbackId);
    }

    if (this._initApplicantEmploymentCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_applicant.index_mortgage_employments', this._initApplicantEmploymentCallbackId);
    }

    if (this._initCoparticipantEmploymentCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_coparticipant.index_mortgage_employments', this._initCoparticipantEmploymentCallbackId);
    }

    if (this._initApplicantLiabilityMortgageCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_applicant.index_mortgage_existing_mortgages', this._initApplicantLiabilityMortgageCallbackId);
    }

    if (this._initCoparticipantLiabilityMortgageCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_coparticipant.index_mortgage_existing_mortgages', this._initCoparticipantLiabilityMortgageCallbackId);
    }

    if (this._initApplicantLiabilitiesCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_applicant.index_mortgage_liabilities', this._initApplicantLiabilitiesCallbackId);
    }

    if (this._initCoparticipantLiabilitiesCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_coparticipant.index_mortgage_liabilities', this._initCoparticipantLiabilitiesCallbackId);
    }

    // Update methods callbacks
    if (this._updateMortgageApplicationCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_applications.self', this._updateMortgageApplicationCallbackId);
    }

    if (this._updateMortgageParticipantsCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_participants.self', this._updateMortgageParticipantsCallbackId);
    }

    if (this._updateMortgageApplicantEmploymentCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_applicant.index_mortgage_employments', this._updateMortgageApplicantEmploymentCallbackId);
    }

    if (this._updateMortgageCoparticipantEmploymentCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_coparticipant.index_mortgage_employments', this._updateMortgageCoparticipantEmploymentCallbackId);
    }

    if (this._updateMortgageApplicantLiabilityMortgageCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_applicant.index_mortgage_existing_mortgages', this._updateMortgageApplicantLiabilityMortgageCallbackId);
    }

    if (this._updateMortgageCoparticipantLiabilityMortgageCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_coparticipant.index_mortgage_existing_mortgages', this._updateMortgageCoparticipantLiabilityMortgageCallbackId);
    }

    if (this._updateMortgageApplicantLiabilitiesCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_applicant.index_mortgage_liabilities', this._updateMortgageApplicantLiabilitiesCallbackId);
    }

    if (this._updateMortgageCoparticipantLiabilitiesCallbackId) {
      this.presenter.removeCallbackFromAction('mortgage_coparticipant.index_mortgage_liabilities', this._updateMortgageCoparticipantLiabilitiesCallbackId);
    }
  };

  this._tray = function () {
    return $('#MortgageApplicationTray').mogo();
  };
}